import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/features/auth/AuthProvider';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Ban, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const RejectedAccessScreen: React.FC = () => {
    const { t } = useTranslation();
    const { currentUser, signOut } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await signOut();
        navigate('/login');
    };

    return (
        <div className="fixed inset-0 z-[100] bg-gray-50 flex items-center justify-center p-4">
            <Card className="w-full max-w-md shadow-2xl border-red-200">
                <CardHeader className="text-center">
                    <div className="mx-auto bg-red-100 p-3 rounded-full w-fit mb-4">
                        <Ban className="h-8 w-8 text-red-600" />
                    </div>
                    <CardTitle className="text-2xl font-bold text-red-900">{t('auth.account_rejected_title')}</CardTitle>
                    <CardDescription className="text-red-700 font-medium mt-2">
                        {t('auth.registration_rejected_desc')}
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-6 text-center">
                    <div className="bg-red-50 border border-red-100 p-4 rounded-lg">
                        <p className="text-sm font-semibold text-red-800 mb-1">{t('auth.reason_label')}</p>
                        <p className="text-gray-700">
                            {currentUser?.rejectionReason || t('auth.no_reason_provided')}
                        </p>
                    </div>

                    <p className="text-sm text-gray-500">
                        {t('auth.mistake_contact_support')}
                    </p>

                    <Button
                        variant="outline"
                        size="lg"
                        className="w-full gap-2 hover:bg-red-50 hover:text-red-600 border-red-200"
                        onClick={handleLogout}
                    >
                        <LogOut className="h-4 w-4" />
                        {t('auth.sign_out')}
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
};
